<template>
  <div>
    <h1>User Details</h1>
    <p>{{ userId }}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userId: this.$route.params.id
    }
  }
}
</script>

<style lang="scss" scoped></style>
